import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, closeModal } from './modules'
import { getAppSalt, queryAgreements, queryNotice, checkIsLogin } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const AddBankCard = Loadable({
    loader: () => import('./AddBankCard'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          bankCardAddBankCardState: state.bankCardAddBankCardState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          checkIsLogin,
          getAppSalt,
          queryAgreements,
          queryNotice,
          closeModal,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/add-bank-card`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AddBankCard {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
